// @react/hooks/useAffiliateCommissionTier.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { affiliateCommissionTierStore } from '@core/stores';

/**
 * React hook for CommissionTier operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAffiliateCommissionTier } from '@react/hooks';
 *
 * const CommissionTierList = observer(() => {
 *   const store = useAffiliateCommissionTier();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAffiliateCommissionTier() {
  return affiliateCommissionTierStore;
}
